import React from "react";

import { useGridUserDataGlobalFiltersContext } from "../../../contexts/GridUserDataGlobalFiltersProvider";
import { useTerminalContext } from "../contexts/TerminalContext";
import type { ViewState } from "../shared/types";
import ConfiguredEmptyState from "./ConfiguredEmptyState";
import { InventorizationView } from "./InventorizationView";

export interface InventorizationTabProps {
  viewState: ViewState;
  setViewState: React.Dispatch<React.SetStateAction<ViewState>>;
  onRequestEditor?: () => void;
  urlSelectedPlaceIds: string[];
  hasPersistedView?: boolean;
}

export const InventorizationTab: React.FC<InventorizationTabProps> = ({
  viewState,
  setViewState,
  onRequestEditor,
  urlSelectedPlaceIds,
  hasPersistedView,
}) => {
    const { data: globalTerminalId = {} } = useGridUserDataGlobalFiltersContext();

    const {
      readyConfig,
      error,
    } = useTerminalContext();

    const terminalId = globalTerminalId?.terminal_id?.[0];

    if (readyConfig) {
      return (
        <InventorizationView
          readyConfig={readyConfig}
          terminalId={terminalId}
          viewState={viewState}
          setViewState={setViewState}
          urlSelectedPlaceIds={urlSelectedPlaceIds}
          hasPersistedView={hasPersistedView}
        />
      );
    }

    return (
      <ConfiguredEmptyState
        terminalId={terminalId}
        error={error}
        onRequestEditor={onRequestEditor}
      />
    );
};
